import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import AddInventory from './AddInventory.js';

function EditInventory(props) {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = async (asset, assetId) => {
        const success = await props.updateAsset(asset, assetId || props.data.id);
        if (success) {
            handleClose();
        }
        return success;
    };

    return (
        <div>
            <IconButton onClick={handleClickOpen}>
                <EditIcon color="primary" />
            </IconButton>
            <AddInventory
                open={open}
                onClose={handleClose}
                onSave={handleSave}
                initialData={props.data}
                assetId={props.data.id}
            />
        </div>
    );
}

export default EditInventory;
